<script lang="ts">
	import type { Snippet } from "svelte";
	import { Section, type SectionTheme } from "#lib/web-ui/primitives/index.js";
	import { featuresDefaults, type FeaturesBaseProps, type FeatureCard } from "./features.types";

	type FeaturesBaseComponentProps = FeaturesBaseProps & {
		children: Snippet<
			[{ label?: string; title: string; subtitle?: string; cards: readonly FeatureCard[] }]
		>;
	};

	let {
		theme = featuresDefaults.theme,
		id = featuresDefaults.id,
		label = featuresDefaults.label,
		title = featuresDefaults.title,
		subtitle = featuresDefaults.subtitle,
		cards = featuresDefaults.cards,
		class: className,
		children
	}: FeaturesBaseComponentProps = $props();
</script>

<Section {theme} {id} class={className}>
	{@render children({ label, title, subtitle, cards })}
</Section>
